import { useSelector } from "react-redux";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const CollaboratorArchivedProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);

  return (
    <ProjectsList
      userType="collaborator"
      pageTitle={`${auth?.user?.display_name || "Your"} Archived Projects`}
      pageDescription="Archived projects remain available here for up to 6 months."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="No archived projects yet."
      detailRoutePath={routeConstant.collaborator.projectDetail.path}
      isArchived={true}
      showArchiveButton={false}
    />
  );
};

export default CollaboratorArchivedProjects;
